import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store';

const getState = ({ speakingSession }: RootState) => speakingSession;

export const tableState = createSelector(getState, (state) => ({
  pageIndex: state.pageIndex,
  pageSize: state.pageSize,
  sortBy: state.sortBy,
}));

export const slotCountsState = createSelector(getState, (state) =>
  state.roomSlotCounts.reduce(
    (accumulator, currentValue) => ({
      available: accumulator.available + currentValue.counts.available,
      awaitingApproval: accumulator.awaitingApproval + currentValue.counts.awaitingApproval,
      rejected: accumulator.rejected + currentValue.counts.rejected,
      booked: accumulator.booked + currentValue.counts.booked,
    }),
    { available: 0, awaitingApproval: 0, rejected: 0, booked: 0 }
  )
);

export const slotCountsWithEditedRoomState = createSelector(getState, (state) =>
  [
    ...state.roomSlotCounts.filter((x) => x.roomId !== state.editedRoomSlotCounts.roomId),
    state.editedRoomSlotCounts,
  ].reduce(
    (accumulator, currentValue) => ({
      available: accumulator.available + currentValue.counts.available,
      awaitingApproval: accumulator.awaitingApproval + currentValue.counts.awaitingApproval,
      rejected: accumulator.rejected + currentValue.counts.rejected,
      booked: accumulator.booked + currentValue.counts.booked,
    }),
    { available: 0, awaitingApproval: 0, rejected: 0, booked: 0 }
  )
);
